import styled from 'styled-components';

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const Label = styled.label`
  color: #25262b;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 140%;
`;
